import "./DealSummarySideCard.css";

import { ReactNode } from "react";

interface DealSummarySideCardProps {
  title: string;
  action?: ReactNode;
  children: ReactNode;
}

export const DealSummarySideCard = ({ title, action, children }: DealSummarySideCardProps): JSX.Element => {
  return (
    <div className="DealSummarySideCard">
      <div className="DealSummarySideCardHeader">
        <h3>{title}</h3>
        {action}
      </div>
      <div className="DealSummarySideCardBody">{children}</div>
    </div>
  );
};
